import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

// material-ui
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

// project imports
import { APP_DEFAULT_PATH } from 'config';

// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection({ reverse, isIcon, sx, to }) {
  const [companyLogo, setCompanyLogo] = useState(null);
  const [appName, setAppName] = useState('');
  const [appAbbr, setAppAbbr] = useState('');
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch perusahaan data untuk mengambil logo dan ico
        const resPerusahaan = await fetch(`${import.meta.env.VITE_APP_API_URL}/perusahaan`);
        const dataPerusahaan = await resPerusahaan.json();
        if (dataPerusahaan && dataPerusahaan.length > 0) {
          const company = dataPerusahaan[0];
          
          if (company.ico) {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
              link = document.createElement('link');
              link.rel = 'icon';
              document.head.appendChild(link);
            }
            link.href = company.ico;
          }
          
          if (company.logo) {
            setCompanyLogo(company.logo);
          }
        }

        // Fetch nama aplikasi
        const resApp = await fetch(`/aplikasi?perusahaan_id=1`);
        const dataApp = await resApp.json();
        if (dataApp) {
          setAppName(dataApp.nama_aplikasi || 'Aplikasi');
          setAppAbbr(dataApp.singkatan || 'APP');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, []);

  return (
    <ButtonBase disableRipple component={Link} to={to || APP_DEFAULT_PATH} sx={sx} aria-label="Logo">
      {loading ? (
        <Skeleton variant="text" width={isIcon ? 35 : 120} height={40} />
      ) : companyLogo ? (
        <img src={companyLogo} alt="Company Logo" style={{ height: isIcon ? '28px' : '35px', objectFit: 'contain' }} />
      ) : (
        <Typography 
          variant="h4" 
          sx={{ 
            color: 'primary.main', 
            fontWeight: 'bold', 
            letterSpacing: 1,
            fontFamily: "'Inter', sans-serif"
          }}
        >
          {isIcon ? appAbbr : appName}
        </Typography>
      )}
    </ButtonBase>
  );
}

LogoSection.propTypes = { reverse: PropTypes.bool, isIcon: PropTypes.bool, sx: PropTypes.any, to: PropTypes.any };
